import { axiosInstance } from '../Config/axios';

const API_URL = `v1/tasks/`;
const API_DELETED_URL = `v1/tasks-deleted/`;
const GAP_URL = 'v1/gaps/';

// Función para listas las tareas (GET)
export const getTasks = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las tareas:', error);
    throw error;
  }
};

// Función para listar una tarea (GET)
export const getTasksByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la tarea con código ${code}:`, error);
    throw error;
  }
};

// Función para actualizar una tarea (PUT)
export const updateTask = async (taskId, data) => {
  try {
    const response = await axiosInstance.patch(`${GAP_URL}issue/task/${taskId}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la tarea`, error);
    throw error;
  }
};

// Obtener status de las tareas
export const getTaskStatus = async () => {
  try {
    const response = await axiosInstance.get(`${GAP_URL}issues/tasks/config/status/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el status de la tarea", error);
    throw error;
  }
};

// Crear comentario de una tarea
export const createTaskComment = async (data) => {
  try {
    const response = await axiosInstance.post(`${GAP_URL}issue/tasks/comment/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al crear el comentario de una tarea`, error);
    throw error;
  }
};

// Función para listar las tareas eliminadas (GET)
export const getTasksDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las tareas eliminadas:', error);
    throw error;
  }
};

// Obtener una tarea eliminado por código (GET)
export const getTasksDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la tarea eliminada con código ${code}:`, error);
    throw error;
  }
};